export default __webpack_public_path__ + "static/Han-0f9d32b01f8eba803b8c95e56ee6e779.jpg";